import { render, staticRenderFns } from "./summaryingOrCompleteNew.vue?vue&type=template&id=20a5c37e&scoped=true"
import script from "./summaryingOrCompleteNew.vue?vue&type=script&lang=js"
export * from "./summaryingOrCompleteNew.vue?vue&type=script&lang=js"
import style0 from "./summaryingOrCompleteNew.vue?vue&type=style&index=0&id=20a5c37e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a5c37e",
  null
  
)

export default component.exports